module.exports = __webpack_public_path__ + "img/ico_down_popup.3f24d6e0.svg";